<template>
  <section>
    <div
      class="right-card"
      :style="{ height: userofficial == 1 ? '389' + 'px' : '' }"
      v-if="name == null"
    >
      <div class="right-card-main">
        <div class="right-card-title">
          <img
            :src="todayDiscountDetails.head_img"
            alt=""
            style="width: 52px; height: 52px"
            v-if="todayDiscountDetails.user_nickname != '官方发布'"
            @click="toUserPage"
          />
          <img src="../../imgs/newsTitle.png" alt="" v-else />

          <!-- <div>{{todayDiscountDetails.user_nickname}}</div> -->
          <div v-if="todayDiscountDetails.user_nickname != '官方发布'">
            <div>
              {{ todayDiscountDetails.user_nickname }}
              <img src="../../imgs/dui.png" alt="" />
            </div>
            <p>{{ todayDiscountDetails.gz_number }}{{ $t("人关注") }}</p>
          </div>
          <!-- <div v-if="todayDiscountDetails.user_nickname=='官方发布'">
                        <div>官方发布 </div>
                    </div>   -->
          <el-divider
            v-if="todayDiscountDetails.user_nickname != '官方发布'"
          ></el-divider>
          <div v-else>
            <div>{{ todayDiscountDetails.user_nickname }}</div>
          </div>
        </div>
        <!-- <div class="cl-code" v-if="userofficial!=1&&userofficial!=2">
                    <ul class="clearfix">
                        <li class="left code-left">
                            <p>{{todayDiscountDetails.gz_number}}</p>
                            <p>关注</p>
                        </li>
                        <li class="left code-left">
                            <p>{{todayDiscountDetails.fans_number}}</p>
                            <p>粉丝</p>
                        </li>
                        <li class="left code-left">
                            <p>{{todayDiscountDetails.getlike_number}}</p>
                            <p>获赞</p>
                        </li>
                    </ul>
                    <div class="professional">
                       <p>职业：<span v-if="todayDiscountDetails.work!=''&&todayDiscountDetails.work!=undefined">{{todayDiscountDetails.work}}</span ><span v-else>暂无</span></p>
                        <p>入住时间： <span v-if="todayDiscountDetails.in_time!=''&&todayDiscountDetails.in_time!=undefined">{{todayDiscountDetails.in_time}}</span ><span v-else>0</span></p>
                        <p v-if="todayDiscountDetails.sign!=''&&todayDiscountDetails.sign!=undefined">{{todayDiscountDetails.sign}}</p>
                        <p v-else>该用户还没有填写签名…</p>
                    </div>
                </div> -->
        <div class="cl-code" v-if="todayDiscountDetails.user_nickname != '官方发布'">
          <el-button
            style="background: #fee60f; color: #333333; margin-left: 10px"
            @click="guanzhu"
            :disabled="userInfoShow"
            v-if="todayDiscountDetails.is_gz == 0"
            ><img
              src="@/imgs/plus.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("关注") }}</div>
          </el-button>
          <el-button
            style="
              background: rgba(254, 230, 15, 0.2);
              color: #fee60f;
              margin-left: 10px;
              padding: 0;
            "
            @click="guanzhu"
            :disabled="userInfoShow"
            v-if="todayDiscountDetails.is_gz == 1"
            ><img
              src="@/imgs/plus.png"
              alt=""
              style="width: 24px; height: 24px; visibility: hidden"
              class="left"
            />
            <div class="left">{{ $t("已关注") }}</div>
          </el-button>
          <el-button
            style="background: #fee60f; color: #333333; margin-left: 10px; padding: 0"
            @click="guanzhu"
            :disabled="userInfoShow"
            v-if="todayDiscountDetails.is_gz == 2"
            ><img
              src="@/imgs/plus.png"
              alt=""
              style="width: 24px; height: 24px; visibility: hidden"
              class="left"
            />
            <div class="left">{{ $t("已互关") }}</div>
          </el-button>
          <el-button style="background: #559aff; color: #ffffff" @click="singelChat">
            <img
              src="@/imgs/list_9.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("私信") }}</div>
          </el-button>
          <el-button @click="shareClick">
            <img
              src="@/imgs/list_3.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("分享") }}</div>
          </el-button>
          <el-button
            @click="shoucang"
            :disabled="userInfoShow"
            v-if="todayDiscountDetails.is_collect == 0"
            ><img
              src="@/imgs/list_4.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("收藏") }}</div>
          </el-button>
          <el-button
            @click="shoucang"
            :disabled="userInfoShow"
            style="background: rgba(254, 230, 15, 0.2); color: #fee60f"
            v-if="todayDiscountDetails.is_collect == 1"
          >
            <img
              src="@/imgs/list_1.png"
              class="left"
              alt=""
              style="width: 24px; height: 24px"
            />
            <div class="left">{{ $t("收藏") }}</div>
          </el-button>
          <el-button @click="dianzan" :disabled="userInfoShow"
            ><img
              src="@/imgs/list_2_1.png"
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ todayDiscountDetails.is_like }}</div>
          </el-button>
          <el-button @click="reportInfo" :disabled="userInfoShow"
            ><img
              src="@/imgs/list_5.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("举报") }}</div>
          </el-button>
        </div>
        <div class="cl-code1" v-else>
          <el-button
            style="
              background: #559aff;
              color: #ffffff;
              width: 248px;
              margin-left: 24px;
              padding: 10px 90px;
            "
            @click="singelChat"
          >
            <img
              src="@/imgs/list_9.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("私信") }}</div>
          </el-button>
          <el-button @click="shareClick">
            <img
              src="@/imgs/list_3.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("分享") }}</div>
          </el-button>
          <el-button
            @click="shoucang"
            :disabled="userInfoShow"
            v-if="todayDiscountDetails.is_collect == 0"
            ><img
              src="@/imgs/list_4.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("收藏") }}</div>
          </el-button>
          <el-button
            @click="shoucang"
            :disabled="userInfoShow"
            style="background: rgba(254, 230, 15, 0.2); color: #fee60f"
            v-if="todayDiscountDetails.is_collect == 1"
          >
            <img
              src="@/imgs/list_1.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ $t("收藏") }}</div>
          </el-button>
          <el-button
            @click="dianzan"
            :disabled="userInfoShow"
            style="
              width: 248px;
              background: rgba(254, 230, 15, 0.2);
              color: #fee60f;
              padding: 10px 90px;
            "
          >
            <img
              src="@/imgs/list_2.png"
              alt=""
              style="width: 24px; height: 24px"
              class="left"
            />
            <div class="left">{{ todayDiscountDetails.is_like }}</div>
          </el-button>
        </div>
      </div>
    </div>
    <div
      class="right-card"
      :style="{ height: userofficial == 1 ? '389' + 'px' : '' }"
      v-else
    >
      <div class="right-card-main">
        <div class="right-card-title">
          <img
            :src="userInfo.head_img"
            alt=""
            style="width: 52px; height: 52px"
            @click="toUserPage"
          />
          <div v-if="userInfo.user_nickname != '官方发布'">
            <div>
              {{ userInfo.user_nickname }} <img src="../../imgs/dui.png" alt="" />
            </div>
            <p>{{ userInfo.gz_number }}{{ $t("人关注") }}</p>
          </div>
          <el-divider v-if="userInfo.user_nickname != '官方发布'"></el-divider>
          <div v-else>
            <div>{{ userInfo.user_nickname }}</div>
          </div>
        </div>
        <div class="cl-code">
          <ul class="clearfix">
            <li class="left code-left">
              <p>{{ userInfo.gz_number }}</p>
              <p>{{ $t("关注") }}</p>
            </li>
            <li class="left code-left">
              <p>{{ userInfo.fans_number }}</p>
              <p>{{ $t("粉丝") }}</p>
            </li>
            <li class="left code-left">
              <p>{{ userInfo.getlike_number }}</p>
              <p>{{ $t("获赞") }}</p>
            </li>
          </ul>
          <div class="professional">
            <p>
              {{ $t("职业：")
              }}<span v-if="userInfo.work != '' && userInfo.work != undefined">{{
                userInfo.work
              }}</span
              ><span v-else>{{ $t("暂无") }}</span>
            </p>
            <p>
              {{ $t("入住时间：") }}
              <span v-if="userInfo.in_time != '' && userInfo.in_time != undefined">{{
                userInfo.in_time
              }}</span
              ><span v-else>0</span>
            </p>
            <p v-if="userInfo.sign != '' && userInfo.sign != undefined">
              {{ userInfo.sign }}
            </p>
            <p v-else>{{ $t("该用户还没有填写签名…") }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="421px" center>
      <div class="clearfix dialog">
        <div class="left" style="margin-left: 108px" @click="copyClick(input2)">
          <img src="../../imgs/weixin.png" alt="" />
          <p style="width: 64px">{{ $t("微信好友") }}</p>
        </div>
        <div class="right" style="margin-right: 108px" @click="copyClick(input2)">
          <img src="../../imgs/weixin.png" alt="" />
          <p style="width: 64px">{{ $t("朋友圈") }}</p>
        </div>
      </div>
      <div style="margin-top: 24px; margin-left: 26px; width: 371px">
        <el-input :placeholder="$t('请输入内容')" v-model="input2">
          <template slot="append"
            ><span @click="copyClick(input2)">{{ $t("复制链接") }}</span></template
          >
        </el-input>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import Service from "@/api/request/index.js";
export default {
  name: "userGuanFang",
  data() {
    return {
      dialogVisible: false,
      title: "",
      input2: "",
      userInfoMobile: {}, //当前登录人信息
      userNumber: {}, //用户信息
      userInfoShow: false,
      name: null,
      userInfo: {},
    };
  },
  props: {
    userofficial: {
      type: Number,
      default: 0,
    },
    todayDiscountDetails: {},
    type: {},
  },
  created() {
    this.userInfoMobile = JSON.parse(localStorage.getItem("USER_INFO"));
    console.log("this.userInfoMobile", this.userInfoMobile);
    this.userNumber = JSON.parse(localStorage.getItem("userNumber"));
    this.input2 = window.location.href;
    this.name = this.$route.query.name || null;
    // 获取用户信息
    this.getMessage(this.$route.query.userId);
  },
  methods: {
    singelChat() {
      console.log("okokokookok");
      let data = {
        friend_img: this.todayDiscountDetails.head_img,
        friend_name: this.todayDiscountDetails.user_nickname,
        friend_id: "hafa" + this.todayDiscountDetails.user_id,
      };
      this.$emit("sixin", data);
    },
    // 分享
    shareClick() {
      this.input2 = window.location.href;
      this.dialogVisible = true;
      this.title = this.$t("分享");
      console.info("this.userInfo", this.userInfo, window.location);
    },
    // 复制链接
    copyClick(context) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      this.$message.success(this.$t("已成功复制到剪贴板"));
      // 复制后移除输入框
      oInput.remove();
      this.$nextTick(() => {
        this.dialogVisible = false;
      });
    },
    // 举报
    reportInfo() {
      this.$router.push({
        url: "/report",
        name: "report",
        query: {
          type: 1,
          user_id: this.$route.query.userId,
          report_article_type: this.$route.query.report_article_type,
        },
      });
    },
    // 关注
    guanzhu() {
      console.log("guanzhu");
      //关注/取消关注
      Service.post62bd55cd493f2({
        user_id: this.todayDiscountDetails.user_id,
      }).then((res) => {
        console.info("res", res);
        if (res.code == 1) {
          this.$message.success(res.msg);
          return this.$emit("guanzhu");
        }
        return this.$message.success(res.msg);
      });
    },
    // 收藏
    shoucang() {
      Service.post62bc0882b98c1({
        id: this.$route.query.userId,
        type: this.type,
      }).then((res) => {
        console.info("res", res);
        if (res.code == 1) {
          this.$message.success(res.msg);
          return this.$emit("guanzhu");
        }
        return this.$message.success(res.msg);
      });
    },
    // 点赞
    dianzan() {
      Service.post62bc08003d16d({
        id: this.$route.query.userId,
        type: this.type,
      }).then((res) => {
        console.info("res", res);
        if (res.code == 1) {
          this.$message.success(res.msg);
          return this.$emit("guanzhu");
        }
        return this.$message.success(res.msg);
      });
    },
    // 头像进入他人主页
    toUserPage() {
      console.log("this.userInfo", this.userInfo);
      this.$router.push({
        path: "/othersPage",
        query: {
          user_id: this.todayDiscountDetails.user_id || this.userInfo.id,
        },
      });
    },
    getMessage() {
      // debugger
      console.log("this.$route.query.userId ", this.$route.query.userId);
      Service.post62bd01fd4eb3d({
        user_id:
          this.$route.query.userId != undefined
            ? this.$route.query.userId
            : this.userInfoMobile.id,
      }).then((res) => {
        if (res.code != 1) {
          // this.$message.error(res.msg)
          return;
        }
        this.userInfo = res.data;
        console.log(
          "res.data.id",
          res.data,
          this.$route.query.userId,
          this.userInfoMobile
        );
        if (res.data.user_id == this.userInfoMobile.id) {
          this.userInfoShow = true;
        } else {
          this.userInfoShow = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";

/deep/ .right-card {
  width: 330px;
  height: 356px;
  // padding: 24px;
}

/deep/ .right-card-main {
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
}

/deep/ .right-card-title {
  text-align: center;

  p {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  img {
    border-radius: 100%;
  }
}

/deep/ .el-carousel__container {
  height: 356px;
}

/deep/ .cl-left {
  margin-bottom: 0;
  margin-top: 20px;
}

.code-left {
  width: 30%;
  position: relative;

  p:first-child {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}

.code-left::after {
  width: 1px;
  height: 28px;
  background: #eeeeee;
  content: "";
  display: block;
  clear: both;
  position: absolute;
  right: -1px;
  top: 22px;
}

.code-left:last-child::after {
  width: 0;
}

.professional {
  margin-top: 35px;

  p {
    text-align: left;
    margin-bottom: 16px;
  }
}

/deep/ .el-button {
  height: 44px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  padding: 10px;
  width: 121px;
  background: #f6f6f6;
  margin-bottom: 24px;
  border: 0;
  line-height: 23px;
}

/deep/ .el-button:nth-child(2n) {
  margin-left: 24px;
}

.cl-code1 {
  margin-top: 24px;
}

/deep/ .el-dialog__headerbtn {
  display: none;
}

.dialog {
  text-align: center;
}

/deep/ .el-dialog__body {
  padding: 25px 0;
}

/deep/ .el-dialog__body .el-input {
  width: 100% !important;
}

/deep/ .el-dialog {
  background: #ffffff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1);
  border-radius: 4px 4px 4px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/userGuan/userGuanFang.vue